import type { AnalyticsData, AnalyticsEventDeclaration } from '@app/packages/analytics/declaration'
import { analyticsEventGroup } from '@app/packages/analytics/declaration'
import type { EventProviderToken } from '@app/packages/analytics/providers'

/**
 * A link reports two events, and the suffix that tells them apart used to be concatenated inside
 * `Link` at send time. They are declared together instead, by whoever renders the link — so a name
 * lives with its feature rather than in a register of every link in the app.
 */
export type LinkEvent = { click: AnalyticsEventDeclaration; keydown: AnalyticsEventDeclaration }

export const linkEvent = (
  name: string,
  options: {
    data?: AnalyticsData
    /** For a link Metrika and GTM also count — what `setGAYS()` marked before. */
    providers?: [EventProviderToken, ...EventProviderToken[]]
  } = {}
): LinkEvent =>
  analyticsEventGroup(
    {
      click: () => ({
        // Followed the {name} link with a pointer.
        type: `${name}.click`,
        data: options.data,
      }),
      /** A separate event, not the one above with a modifier: 1974 of these arrive in a month. */
      keydown: () => ({
        // Followed the {name} link from the keyboard.
        type: `${name}.keydown`,
        data: options.data,
      }),
    },
    options.providers
  )
